import axios from 'axios'

export const qrcodeAerverUrl = 'http://www.jianshenweb.com/pm/'

export function generateQrcode () {
  return new Promise((resolve, reject) => {
    axios.get(qrcodeAerverUrl + 'wxOpenIdAction!genOpenIdQrcode.action')
      .then(function (response) {
        let data = response.data
        resolve({
          uuid: data.uuid,
          qrcode: qrcodeAerverUrl + data.qrcode
        })
      })
      .catch(function (error) {
        console.log(error)
      })
  })
}

export function getOpenId (uuid) {
  return new Promise((resolve, reject) => {
    axios.get(qrcodeAerverUrl + 'wxOpenIdAction!refreshOpenId.action', {params: {uuid: uuid, r: Math.random()}})
      .then(function (response) {
        let data = response.data
        console.log(data)
        resolve(data.openId)
      })
      .catch(function (error) {
        console.log(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/qrcodeApi.js